import { Redirect } from 'expo-router'
import { type FC } from 'react'
import { graphql, usePreloadedQuery, type PreloadedQuery } from 'react-relay'

import { type UserNavigatorQuery } from '@/__generated__/UserNavigatorQuery.graphql'

import { UserNavigatorView } from './UserNavigatorView'

export interface UserNavigatorProps {
  queryRef: PreloadedQuery<UserNavigatorQuery>
}

export const UserNavigator: FC<UserNavigatorProps> = ({ queryRef }) => {
  const queryData = usePreloadedQuery<UserNavigatorQuery>(
    graphql`
      query UserNavigatorQuery {
        currentUser {
          status
        }
        ...UserNavigatorView_query
      }
    `,
    queryRef
  )

  const status = queryData?.currentUser?.status

  // confine restricted users to their dedicated screen regardless of which (user) route they land on
  if (status === 'BANNED' || status === 'APPEAL') {
    return <Redirect href='/banned' />
  }

  if (status === 'INACTIVE' || status === 'SCHEDULED_FOR_DELETION') {
    return <Redirect href='/account-inactive' />
  }

  return <UserNavigatorView queryRef={queryData} />
}
